import React from 'react'
import './UserHomeStatisticsItem.css'

export default function UserHomeStatisticsItem({background ,title , icon, count}) {
  return (
    <div className='user-home-statistics-item' style={{background : background}}>
        <div className='user-home-statistics-icon'>
            {icon}
        </div>
        <div className='user-home-statistics-content'>
            <h3>{title}</h3>
            <span>{count}</span>
        </div>
    </div>
  )
}
